import {
	Box,
	Button,
	ButtonGroup,
	Container,
	Drawer,
	DrawerContent,
	DrawerOverlay,
	Flex,
	HStack,
	Image,
	Link,
	useDisclosure,
} from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";

import { ToggleButton } from "../layout/ToggleButton";
import { Sidebar } from "./Sidebar";

const navItems = [
	{ label: "Home", to: "/" },
	{ label: "See It In Use", to: "/example-farms" },
	{ label: "News & Media", to: "/news" },
	{ label: "About Us", to: "/about-us" },
	{ label: "Contact Us", to: "/contact-us" },
];

export const Navbar = () => {
	const { isOpen, onToggle, onClose } = useDisclosure();

	return (
		<Box as="section">
			<Box
				as="nav"
				bg="rgba(255, 255, 255, 0.72)"
				boxShadow="0 8px 24px rgba(15, 23, 42, 0.12)"
				position="fixed"
				top="0"
				left="0"
				right="0"
				w="100%"
				zIndex="overlay"
				backdropFilter="saturate(180%) blur(14px)"
				borderBottom="1px solid"
				borderColor="whiteAlpha.700"
			>
				<Container maxW="1480px" py={{ base: "4", lg: "5" }}>
					<HStack spacing="6" justify="space-between">
						<Link as={ReactLink} to="/">
							<Image
								src="gecologo.png"
								alt="Geco"
								height="30px"
							/>
						</Link>
						<Flex display={{ base: "none", lg: "flex" }} justify="space-between" flex="1">
							<ButtonGroup variant="text" colorScheme="gray" spacing="3">
								{navItems.map((item) => (
									<Button key={item.to} as={ReactLink} to={item.to}>
										{item.label}
									</Button>
								))}
							</ButtonGroup>
						</Flex>
						<Flex display={{ base: "flex", lg: "none" }} justify="space-between">
							<ToggleButton
								isOpen={isOpen}
								aria-label="Open Menu"
								onClick={onToggle}
							/>
							<Drawer
								isOpen={isOpen}
								placement="left"
								onClose={onClose}
								isFullHeight
								preserveScrollBarGap
								trapFocus={false}
							>
								<DrawerOverlay />
								<DrawerContent>
									<Sidebar />
								</DrawerContent>
							</Drawer>
						</Flex>
					</HStack>
				</Container>
			</Box>
		</Box>
	);
};
